<template>
  <div class="fixed inset-0 bg-gray-900 bg-opacity-70 flex items-center justify-center p-4 z-50 transition-opacity duration-300">
    <div class="relative w-full max-w-3xl bg-gray-800 text-white rounded-lg shadow-xl p-5 flex flex-col gap-4">
      <button 
        @click="$emit('close')" 
        class="absolute top-4 right-4 text-gray-400 hover:text-indigo-300 transition-colors duration-200"
      >
        <i class="fas fa-times text-lg"></i>
      </button>
      <h3 class="text-xl font-semibold text-indigo-300 flex items-center">
        <i class="fas fa-info-circle mr-2 text-sm"></i> รายละเอียด {{ statName }}
      </h3>
      <div class="space-y-3">
        <div class="flex items-center space-x-2 bg-gray-700 border border-gray-600 p-2 rounded-md transition-all duration-200 hover:bg-gray-600 hover:border-indigo-400">
          <i class="fas fa-arrow-up text-indigo-400 text-sm"></i>
          <span class="flex-1 text-sm text-indigo-200">จากการอัพสเตตัส:</span>
          <span class="font-semibold text-sm text-indigo-200">{{ breakdown.base }}</span>
        </div>
        <div class="flex items-center space-x-2 bg-gray-700 border border-gray-600 p-2 rounded-md transition-all duration-200 hover:bg-gray-600 hover:border-indigo-400">
          <i class="fas fa-shirt text-indigo-400 text-sm"></i>
          <span class="flex-1 text-sm text-indigo-200">จากไอเทม:</span>
          <span class="font-semibold text-sm text-indigo-200">{{ breakdown.item }}</span>
        </div>
        <div class="flex items-center space-x-2 bg-gray-700 border border-gray-600 p-2 rounded-md transition-all duration-200 hover:bg-gray-600 hover:border-indigo-400">
          <i class="fas fa-star text-indigo-400 text-sm"></i>
          <span class="flex-1 text-sm text-indigo-200">จากโบนัสเซ็ต:</span>
          <span class="font-semibold text-sm text-indigo-200">{{ breakdown.bonus }}</span>
        </div>
        <div class="flex items-center space-x-2 bg-gray-700 border border-gray-600 p-2 rounded-md transition-all duration-200 hover:bg-gray-600 hover:border-indigo-400">
          <i class="fas fa-book text-indigo-400 text-sm"></i>
          <span class="flex-1 text-sm text-indigo-200">จากทักษะ:</span>
          <span class="font-semibold text-sm text-indigo-200">{{ breakdown.skill }}</span>
        </div>
        <div class="flex items-center space-x-2 bg-gray-700 border border-gray-600 p-2 rounded-md transition-all duration-200 hover:bg-gray-600 hover:border-indigo-400">
          <i class="fas fa-user text-indigo-400 text-sm"></i>
          <span class="flex-1 text-sm text-indigo-200">จากลักษณะนิสัย:</span>
          <span class="font-semibold text-sm text-indigo-200">{{ breakdown.trait }}</span>
        </div>
        <div class="flex items-center space-x-2 bg-gray-700 border border-gray-600 p-2 rounded-md transition-all duration-200 hover:bg-gray-600 hover:border-indigo-400">
          <i class="fas fa-paint-brush text-indigo-400 text-sm"></i>
          <span class="flex-1 text-sm text-indigo-200">จากรอยสัก:</span>
          <span class="font-semibold text-sm text-indigo-200">{{ breakdown.tattoo }}</span>
        </div>
        <div class="flex items-center space-x-2 bg-gray-700 border border-gray-600 p-2 rounded-md transition-all duration-200 hover:bg-gray-600 hover:border-indigo-400">
          <i class="fas fa-ghost text-indigo-400 text-sm"></i>
          <span class="flex-1 text-sm text-indigo-200">จากวิญญาณ:</span>
          <span class="font-semibold text-sm text-indigo-200">{{ breakdown.ghost }}</span>
        </div>
        <div class="flex items-center space-x-2 bg-gray-700 border border-gray-600 p-2 rounded-md transition-all duration-200 hover:bg-gray-600 hover:border-indigo-400">
          <i class="fas fa-crown text-indigo-400 text-sm"></i>
          <span class="flex-1 text-sm text-indigo-200">จากฉายา:</span>
          <span class="font-semibold text-sm text-indigo-200">{{ breakdown.title }}</span>
        </div>
        <div class="flex items-center space-x-2 bg-indigo-600 p-2 rounded-md transition-all duration-200">
          <i class="fas fa-star text-white text-sm"></i>
          <span class="flex-1 text-sm font-semibold text-white">รวม:</span>
          <span class="font-semibold text-sm text-white">{{ breakdown.total }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatDetailsModal',
  props: {
    statName: {
      type: String,
      required: true
    },
    breakdown: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
button:not(:disabled):active {
  transform: scale(0.98);
}
</style>